import { Component, OnInit, AfterContentInit, AfterViewInit, ViewChild, ElementRef, Input, Output, EventEmitter } from '@angular/core';
import { BaseComponent } from '../../base/base.component';
import { ActivatedRoute, Router } from '@angular/router';
import { AccountService } from '../../../services/account.service';
import { SessionBookingVM } from '../../../models/SessionBookingVM';
import { StripeService } from 'ngx-stripe';
import { StripeElements, StripeCardElement } from '@stripe/stripe-js';
declare var Stripe;

@Component({
    selector: 'b2c-session-payment',
    templateUrl: './b2c-sessionpayment.component.html'
})
export class B2CSessionPaymentComponent extends BaseComponent implements OnInit {

    @ViewChild('card-element') cardElementRef: ElementRef;
    @Input() sessionDetails: SessionBookingVM | null = null;
    @Output() bookingResponse: EventEmitter<Response> = new EventEmitter();

    elements: StripeElements;
    card: StripeCardElement;
    isCardDetailsValid = false;
    isTermsAccepted = false;

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private accService: AccountService,
        private stripeService: StripeService
    ) {
        super(route);
    }

    ngOnInit(): void {
        let self = this;

        //payment intend
        self.accService.reserveBooking(self.sessionDetails)
            .subscribe(
                (returnValue) => {
                    self.sessionDetails = returnValue;
                },
                e => {
                    self.showDialog(e, true);
                },
                () => { }
            );

        //mount card
        this.stripeService.elements()
            .subscribe(e => {
                if (self.card == null) {
                    self.elements = e;

                    self.card = self.elements.create('card', {
                        style: {
                            base: {
                                color: '#32325d',
                                lineHeight: '18px',
                                fontFamily: '"Roboto", sans-serif',
                                fontSmoothing: 'antialiased',
                                fontSize: '16px',
                                '::placeholder': {
                                    color: '#aab7c4'
                                }
                            },
                            invalid: {
                                color: '#ec1649',
                                iconColor: '#ec1649'
                            }
                        }
                    });

                    self.card.mount('#card-element');

                    // set event handlers
                    this.card.on('change', function (event) {
                        var displayError = document.getElementById('card-errors');
                        if (event.error) {
                            self.isCardDetailsValid = false;
                            displayError.textContent = event.error.message;
                        } else {
                            self.isCardDetailsValid = true;
                            displayError.textContent = '';
                        }
                    });
                }
            });
    }

    termsCheckboxChange(chkbox: boolean) {
        this.isTermsAccepted = chkbox;
    }

    commitBooking() {
        let self = this;
        if (!self.isCardDetailsValid) {
            return;
        }

        const name = this.me.username;
        self.emitDisplayLoadingDialog(true);

        var stripeInstance: any = self.stripeService.getInstance();

        stripeInstance.handleCardPayment(
            self.sessionDetails.token, self.card, {
            payment_method_data: {
                billing_details: { name: name }
            }
        }
        ).then(function (result) {
            if (result.error) {
                self.showDialog("Payment Failure", true);
                self.emitDisplayLoadingDialog(false);
            } else {
                //payment success
                self.accService.commitBooking(self.sessionDetails)
                    .subscribe(
                        (returnValue) => self.bookingResponse.emit(returnValue),
                        e => {
                            self.bookingResponse.emit(e);
                        },
                        () => { }
                    );
                self.accService.newSessionBooking = null;
            }
        });

        return false;
    }
}
